<template>
  <div class="mb-12">
    <v-row class="flex-column flex-md-row">
      <v-col>
        <v-card-title
          class="display-2 letter-spacing-compact font-weight-bold mb-md-12 align-center px-5"
        >
          Tours
        </v-card-title>
      </v-col>
      <v-col>
        <v-text-field
          class="px-5"
          append-icon="$search"
          label="Search"
          v-model="search"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :fixed-header="true"
          class="primary-table border-radius-0 v-data-table-1 v-data-table-1--style2"
          :headers="headers"
          :items="tours"
          :loading="model.fetching"
          loading-text="fetching data..."
          no-data-text="No data"
          no-results-text="Unable to find any data"
          :options.sync="pagination"
          :server-items-length="total"
        >
          <template v-slot:item.location="{ value }">
            {{ value.lat }}, {{ value.lng }}
          </template>
          <template v-slot:item.projects="{ value }">
            {{ value.map((project) => project.name).join(', ') }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon @click="edit(item)">$edit</v-icon>
            <v-icon @click="remove(item)">$delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card-actions class="mt-10 px-5">
          <v-btn
            v-if="!createMode"
            depressed
            large
            color="black"
            class="white--text px-8 justify-space-between justify-md-center font-weight-bold"
            @click="newTour()"
            min-width="275px"
          >
            New Tour
            <v-icon class="ml-5" right>$plus</v-icon>
          </v-btn>
          <v-btn
            v-else
            depressed
            large
            color="black"
            class="white--text px-5 font-weight-bold"
            @click="newTour()"
            min-width="275px"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Tour from '@models/Tour';

export default {
  name: 'ToursList',
  props: {
    tours: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Tour,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    createMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      pagination: {
        sortBy: ['created_at'],
        itemsPerPage: 10,
        page: 1,
        sortDesc: [true],
      },
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type.name', sortable: false },
        { text: 'Coordinates', value: 'location' },
        { text: 'Projects', value: 'projects', sortable: false },
        { text: 'Action', value: 'action', sortable: false },
      ],
    };
  },
  watch: {
    search() {
      this.fetchData();
    },
    pagination(pagination) {
      Object.assign(this.model, pagination);
      this.fetchData();
    },
  },
  methods: {
    fetchData() {
      this.syncPagination();
      this.$emit('fetch');
    },
    syncPagination() {
      Object.assign(this.model, this.pagination);
      (this.search &&
        this.model.setFilters({
          name: this.search,
        })) ||
        this.model.removeFilter('name');
    },
    newTour() {
      this.$emit('newTour');
    },
    edit(tour) {
      this.$emit('edit', tour);
    },
    async remove(tour) {
      if (
        await $question(
          'Are you sure, you want to delete this tour?',
          'This cannot be undone!'
        )
      ) {
        if (await this.model.delete(tour.id)) {
          $showSuccess('Tour has been removed.', 'delete-tours');
          this.fetchData();
        }
      }
    },
  },
};
</script>
